export default {"src":"/_next/static/media/google_pay_icon.196cfb6a.svg","height":173,"width":436,"blurWidth":0,"blurHeight":0};